/**
 * Returns the URL hash without the leading "#", percent-decoded.
 * location.hash is percent-encoded ("#%C3%BCbersicht") while anchor ids hold the decoded characters, so decode
 * before comparing. A malformed escape sequence returns the raw value.
 */
export const readDecodedHash = () => {
    const raw = window.location.hash.replace(/^#/, "");
    try {
        return decodeURIComponent(raw);
    }
    catch {
        return raw;
    }
};
